import GamesInfo from "./GamesInfo";
const data = {
  name: "Games",
  props: {
    items: GamesInfo,
  },
};
export default data;
